import { createTheme } from "@mui/material/styles";

export const DOMAIN_NAME =
  process.env.REACT_APP_DEPLOY === "qa"
    ? "9dots-rewriters-qa.org"
    : "9dots-biycr-dev.org";

/** @todo finalize poll ids, labels, and sectionColors */
// object to get label and sectionColor from slide id
export const SLIDE_ADDITIONAL_INFO = Object.freeze({
  title: { sectionColor: "#EB564B" },
  warmup: { label: "Warm Up" },
  lastepisode: { label: "Last Episode", sectionColor: "#FF9166" },
  getready: { label: "Get Ready", sectionColor: "#FFE478" },
  explore: { label: "Explore", sectionColor: "#9FCE3A" },
  learn: { label: "Learn", sectionColor: "#0089FF" },
  keepgoing: { label: "Keep Going", sectionColor: "#D89EFF" },
  checkin: { label: "Check In", sectionColor: "#6841C0" },
  playtime: { label: "Play!", nextLabel: "Start Timer", notch: true },
  pollpreview: { label: "Poll Preview", notch: true },
  polltime: { label: "Poll Time!" },
  pollresults: { label: "Poll Results" },
  letsdiscuss: { label: "Let's Discuss", notch: true },
  discusspartner: { label: "Discuss with a partner", notch: true },
  end: { label: "End" },
});

export const PLAYER_STATUS = {
  PAUSED: "paused",
  POLLING: "polling",
  PLAYING: "playing",
};

export const PLAYTIME_PHASE = {
  LOGIN: "login",
  EXPLORE: "explore",
  KEEPGOING: "keepgoing",
};

export const DISCUSS_PARTNER = "discusspartner";

export const TIMER_MODAL_SUBPHASE = {
  START: "start",
  END: "end",
  END_EARLY: "endEarly",
};

export const EDITING_STATE = {
  IS_EDITING: "IS_EDITING",
  CANCEL_EDIT_QUEUED: "CANCEL_EDIT_QUEUED",
  CONFIRM_EDIT_QUEUED: "CONFIRM_EDIT_QUEUED",
};

export const PALETTE = {
  black: "#212121",
  green: "#00E676",
  contrastGreen: "#00A152",
  darkGreen: "#003918",
  desaturateGreen: "#1CB35E",
  gray: "#BDBDBD",
  lightGray: "#d9d9d9",
  underlineGray: "#9e9e9e",
};

export const getColorWithAlpha = (hexColor, opacityDecimal) =>
  `${hexColor}${Math.round(opacityDecimal * 255).toString(16)}`;

export const BUTTON_THEME = createTheme({
  palette: {
    primary: {
      main: PALETTE.green,
      contrastText: PALETTE.darkGreen,
      dark: PALETTE.desaturateGreen,
    },
    secondary: {
      main: PALETTE.lightGray,
      contrastText: PALETTE.black,
      dark: PALETTE.gray,
    },
  },
});

const NAV_KEYS = {
  prev: {
    PageUp: true,
    ArrowUp: true,
    ArrowLeft: true,
  },
  next: {
    PageDown: true,
    ArrowDown: true,
    ArrowRight: true,
  },
};
export const isNavKey = (type, key) => !!NAV_KEYS[type][key];
export const DIRECTION = {
  NEXT: "next",
  PREV: "prev",
};

export const BLOCK_KEYS = Object.freeze({
  and: "and",
  boom: "boom",
  defeat: "defeat",
  godown: "godown",
  goleft: "goleft",
  goright: "goright",
  goup: "goup",
  hot: "hot",
  is: "is",
  melt: "melt",
  not: "not",
  open: "open",
  push: "push",
  safe: "safe",
  shut: "shut",
  sink: "sink",
  stop: "stop",
  weak: "weak",
  win: "win",
  you: "you",
});

export const OBJECT_KEYS = Object.freeze({
  amethyst: "amethyst",
  apple: "apple",
  ball: "ball",
  book: "book",
  bookshelf: "bookshelf",
  box: "box",
  bubble: "bubble",
  carrots: "carrots",
  chicken: "chicken",
  cloud: "cloud",
  coin: "coin",
  crab: "crab",
  crabCowboy: "crabCowboy",
  dresserChecker: "dresserChecker",
  dresserFloral: "dresserFloral",
  fire: "fire",
  fly: "fly",
  fossil: "fossil",
  frog: "frog",
  frogMlem: "frogMlem",
  fungus: "fungus",
  garnet: "garnet",
  gold: "gold",
  grass: "grass",
  heart: "heart",
  ice: "ice",
  lava: "lava",
  lavaPit: "lavaPit",
  lavaUnderwater: "lavaUnderwater",
  map: "map",
  moat: "moat",
  mushroom: "mushroom",
  pearl: "pearl",
  puddle: "puddle",
  rocks: "rocks",
  rocksAlgae: "rocksAlgae",
  rocksBlue: "rocksBlue",
  rocksCrystalBlue: "rocksCrystalBlue",
  rocksCrystalPurple: "rocksCrystalPurple",
  rocksGrey: "rocksGrey",
  rocksSnow: "rocksSnow",
  rocksTidepool: "rocksTidepool",
  rugPeach: "rugPeach",
  rugPink: "rugPink",
  rugTeal: "rugTeal",
  sandcastle: "sandcastle",
  seaweed: "seaweed",
  shrub: "shrub",
  snow: "snow",
  snowball: "snowball",
  snowbear: "snowbear",
  snowbunny: "snowbunny",
  soilCarrots: "soilCarrots",
  soilSprout: "soilSprout",
  spike: "spike",
  starfish: "starfish",
  sword: "sword",
  tableChecker: "tableChecker",
  tableLine: "tableLine",
  treasure: "treasure",
  urchin: "urchin",
  wallPlatformGrey: "wallPlatformGrey",
  wallPlatformOrange: "wallPlatformOrange",
  wallPlatformPlantsGrey: "wallPlatformPlantsGrey",
  wallPlatformPlantsOrange: "wallPlatformPlantsOrange",
  water: "water",
  watermelon: "watermelon",
});

export const CHARACTER_KEYS = Object.freeze({
  enoki: "enoki",
  lino: "lino",
  lopi: "lopi",
  luna: "luna",
  mentiMasked: "mentiMasked",
  mentiUnmasked: "mentiUnmasked",
  morel: "morel",
  olive: "olive",
  oliveBowl: "oliveBowl",
  piney: "piney",
  sol: "sol",
  zorro: "zorro",
});
